import PeopleSVG from "./svg/people.svg?react";

const ContactBadge = ({ style, className = "", ...props }) => (
  <span className={`record-badge people ${className}`} style={style} aria-hidden="true">
    <PeopleSVG {...props} />
  </span>
);

export default ContactBadge;
